/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import React from 'react';

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import AkFlag from '@atlaskit/flag/flag';
import type { FlagProps } from '@atlaskit/flag/types';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { withLocalIntl } from '../../common/utils/i18n/intl-provider';

import { messages } from './messages';

export type Props = {
	/** Flag id passed through to AkFlag. */
	id: FlagProps['id'];
	/** Called when the flag is dismissed. */
	onDismiss: FlagProps['onDismissed'];
};

const SUPPORT_LINK = 'https://support.atlassian.com/contact/';

export const InviteOnThirdPartyLinkErrorFlagNoIntl = ({
	onDismiss,
	...props
}: Props): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<AkFlag
			{...props}
			testId="invite-on-third-party-link-error-flag"
			icon={<ErrorIcon spacing="spacious" label="Error" color={token('color.icon.danger')} />}
			onDismissed={onDismiss}
			title={<Box as="p">{formatMessage(messages.title)}</Box>}
			description={<Text as="p">{formatMessage(messages.description)}</Text>}
			actions={[
				{
					content: formatMessage(messages.action),
					href: SUPPORT_LINK,
					target: '_blank',
				},
			]}
		/>
	);
};

export const InviteOnThirdPartyLinkErrorFlag: (props: Props) => React.JSX.Element = withLocalIntl(
	InviteOnThirdPartyLinkErrorFlagNoIntl,
);
